import React, { useCallback, useState } from 'react'
import { CodonationSelection } from '../codonation_selection'
import { FormikCents } from '..'
import { I18nHtml, Modal } from 'shared'
import { SummaryProps } from './types'

export const Summary = (props: SummaryProps): JSX.Element | null => {
  if (!props.config.showCodonation) return null

  return (
    <>
      {props.explanation || <Explanation {...props} />}
      <div className="donations-form-codonation-selection">
        <table className="bpc-table donation-summary">
          <tbody>
            <tr style={{ borderTop: 'hidden' }}>
              <td className="pl-0! py-4">
                <CodonationSelection config={props.config} display={props.display} />
              </td>
              <td className="text-right pr-0! py-4" style={{ verticalAlign: 'middle' }}>
                <span className="font-bold text-base whitespace-nowrap">
                  <span>+ </span>
                  <FormikCents precision={2} fields={['codonation_cents']} />
                </span>
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="text-right pr-0! py-4">
                <strong className="text-lg">
                  <span>{i18n.t('donate.summary.total')}</span>{' '}
                  <FormikCents precision={2} fields={['amount_cents', 'codonation_cents']} />
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

const Explanation = (props: SummaryProps): JSX.Element => {
  const [showWhyModal, setShowWhyModal] = useState(false)
  const openWhyModal = useCallback(() => {
    setShowWhyModal(true)
  }, [])
  const hideWhyModal = useCallback(() => {
    setShowWhyModal(false)
  }, [])

  return (
    <>
      <h4 className="headline">{i18n.t('donate.summary.headline')}</h4>
      <p>
        <span>{i18n.t('donate.summary.description_html')}</span>
        <button type="button" className="simulated-link ml-1 mr-1" onClick={openWhyModal}>
          {i18n.t('donate.codonation_selection.why_modal.open_button')}
        </button>
      </p>

      <Modal
        id="donation-summary-modal"
        onHide={hideWhyModal}
        show={showWhyModal}
        header={i18n.t(`donate.codonation_selection.why_modal.headline`)}
      >
        <I18nHtml
          as="div"
          i18nKey={`donate.codonation_selection.why_modal.${props.config.wording}`}
          options={{ receiver_name: props.display.receiverName }}
        />
        <button className="my-1 btn btn-primary" onClick={hideWhyModal} type="button">
          {i18n.t('donate.codonation_selection.why_modal.close_button')}
        </button>
      </Modal>
    </>
  )
}
